import { createContext, useContext } from 'react';
import { GithubPublicAppInstallationContextValue } from './types';

export const GithubPublicAppInstallationContext = createContext<
  GithubPublicAppInstallationContextValue | undefined
>(undefined);

/**
 * Hook to access the GitHub MT installation context.
 * @returns The MT installation context value containing the marketplace phase and error code.
 * @throws Error if used outside GithubPublicAppInstallationContext.Provider
 */
export const useGithubPublicAppInstallation = () => {
  const context = useContext(GithubPublicAppInstallationContext);

  if (!context) {
    throw new Error(
      'useGithubPublicAppInstallation must be used within GithubPublicAppInstallationContext.Provider',
    );
  }

  return context;
};
